import api from "../../client";

import { UpdateTagPayload, UpdateTagResponseData } from "../../types/tag";

export const updateTagRequest = async (
  id: string,
  payload: UpdateTagPayload,
): Promise<UpdateTagResponseData> => {
  const { data } = await api.put<UpdateTagResponseData>(`/tag/${id}`, payload);

  return data;
};
